export default "__VITE_ASSET__BD$qIImR__"